import { useQuery } from '@fv/client-core'

import { shipperFetch } from '@/utils/shipperFetch'

import type { CustomsBrokerDto } from './brokerTypes'

export type CustomsBrokerByLocation = {
  addressBookId?: string
  postalCode: string
}

const fetchDefaultBroker = async ({
  addressBookId,
  postalCode,
}: CustomsBrokerByLocation) =>
  shipperFetch<CustomsBrokerDto | null>('/addresses/location-customs-broker', {
    query: { postalCode, addressBookId },
  })

export function useCustomsBrokerByLocation(
  args: CustomsBrokerByLocation,
  enabled = !!args.addressBookId || !!args.postalCode,
) {
  return useQuery(
    ['location-customs-broker', args.addressBookId || args.postalCode],
    () => fetchDefaultBroker(args),
    {
      enabled,
      refetchOnMount: q => (q.state.data === null ? 'always' : true),
    },
  )
}
